import { nanoid } from 'nanoid'

import { warnDev } from '@/utils/warnDev'

import type { PathType } from '../TableBase.types'
import { getPropertyAtPath } from './getPropertyAtPath'

export const getRowId = <Data extends Record<string, unknown>, Path extends PathType<Data>>(
  rowIdProperty: Path | ((data: Data) => string) | undefined
) => {
  if (typeof rowIdProperty === 'function') return rowIdProperty
  if (typeof rowIdProperty === 'string') {
    return (data: Data) => {
      const id = getPropertyAtPath(data, rowIdProperty)
      if (typeof id === 'string' || typeof id === 'number') return id.toString()
      warnDev(
        `getRowId: Random ID was set because provided path "${rowIdProperty}" resolved to non-string/non-number value: ${JSON.stringify(
          id
        )}`
      )
      return nanoid()
    }
  }

  return (_: Data) => nanoid()
}
